export type Color = 'red' | 'green' | 'purple' | 'yellow';
export type RingSize = 'small' | 'medium' | 'large';
export type BotDifficulty = 'easy' | 'hard';

export const COLORS: Color[] = ['red', 'green', 'purple', 'yellow'];
export const SIZES: RingSize[] = ['small', 'medium', 'large'];

export const COLOR_LABELS: Record<Color, string> = {
  red: 'Red',
  green: 'Green',
  purple: 'Purple',
  yellow: 'Yellow',
};

export const COLOR_HEX: Record<Color, string> = {
  red: '#e74c3c',
  green: '#27ae60',
  purple: '#8e44ad',
  yellow: '#f39c12',
};

export interface Cell {
  small: Color | null;
  medium: Color | null;
  large: Color | null;
}

export interface PlayerState {
  color: Color;
  name: string;
  pieces: Record<RingSize, number>;
  isBot: boolean;
  botDifficulty: BotDifficulty | null;
  /** Groups colors controlled by the same human in 2-player mode. */
  playerId: number;
}

export interface GameState {
  board: Cell[];
  players: PlayerState[];
  currentPlayerIndex: number;
  winner: Color | null;
  winLine: number[] | null;
}
